import { SiteHeader } from "../components/platform/PlatformChrome";
import { Footer } from "../components/landing/Footer";
import { SankalpaModule } from "../components/sankalpa/SankalpaModule";

/**
 * `/sankalpa` — the standalone mount of the saṅkalpa module (a "secret" route,
 * omitted from nav). The SAME component is embedded in Library documents via
 * the `sankalpa` block (Pūjā Vidhi, preparatory step 3); everything the page
 * does beyond page chrome lives in `components/sankalpa/SankalpaModule`.
 */
export default function Sankalpa() {
  return (
    <>
      <SiteHeader />
      <main className="pt-24 md:pt-28 pb-24">
        <div className="container-edit max-w-[760px]">
          <SankalpaModule />

          <p className="sk-about">
            A <strong>saṅkalpa</strong> fixes a sacred act in time and place and
            declares its purpose. The full form is composed from the living
            pañcāṅga for your location and day — the year, ayana, season, month,
            fortnight, tithi, weekday, nakṣatra, yoga and karaṇa — in the
            traditional order. The <em>mahā-saṅkalpa</em> sets that day inside
            the cosmic reckoning as well; the short form is what is said in daily
            pūjā.
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}
